import { render, staticRenderFns } from "./FormularioBase.vue?vue&type=template&id=054166b6"
import script from "./FormularioBase.vue?vue&type=script&lang=js"
export * from "./FormularioBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports